import { Modal } from "react-bootstrap";
import {
  popCancelBttn, PlayButton, PauseButton, Speaker, RedStop, RecordingIcon, PlusIconBlue,
  SpeakerBlue, RefreshButton,
  imsLoader
} from "../../assets";
import { useEffect, useRef, useState } from "react";
import './AliasModal.css';
import Box from '@mui/material/Box';
import Button from "../Button";
import axios from "axios";
import { useReactMediaRecorder } from "react-media-recorder";
import PhonemeLibrary from "./PhonemeLibrary";
import { Authentication } from "../../utils/authenticationUtilityServices";

const AliasModal = (props) => {
  const [phoneme, setPhoneme] = useState("");
  const [fromLibrary , setFromLibrary] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(true);
  const [textselected, setTextselected] = useState('');
  const [wordLexicon, setWordLexicon] = useState('');
  const [lexiconError, setLexiconError] = useState(false);
  const audioSrc = useRef(new Audio());
  const [isRecording, setIsRecording] = useState(false);
  const [manyPhonemes, setManyPhonemes] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audio, setAudio] = useState();
  const intervalRef = useRef();
  const [suggestPhoneme, setSuggestPhoneme] = useState('');
  const [reload, setReload] = useState(true);
  const [isLibrary, setIsLibrary] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    console.log(props.openAIphoneme)
    if (props.openAIphoneme) {
      props.openAIphoneme.forEach(element => {
        console.log(element.textselected === props.textselected)
        if (element.textselected === props.textselected) {
          console.log(element.phonemeValue)
          setPhoneme(element.phonemeValue)
        }
      });
    }
    //setPhoneme(props.openAIphoneme)
  }, [props.openAIphoneme])

  useEffect(() => {
    if (reload) {
      fetchPhonemeFromAi()
    }
  }, [reload])

  useEffect(() => {
    fetchPhonemeFromAi()
  }, [])

  useEffect(() => {
    audioSrc.current = new Audio(audio);
  }, [audio]);

  const { status, startRecording, stopRecording, mediaBlobUrl } =
    useReactMediaRecorder({
      mediaRecorderOptions: {
        mimeType: "audio/wav",
        bitsPerSecond: 256000,
        audioBitsPerSecond: 256000,
        audioBitrateMode: "constant",
      }
    });

  useEffect(() => {
    setTextselected(props.textselected)
  }, [props.textselected]);

  useEffect(() => {
    if (props.prevGrapheme) {
      setWordLexicon(props.prevGrapheme)
    }
  }, [props.prevGrapheme]);
  useEffect(() => {
    if (wordLexicon) {
      fetchPhonemeFromAi()
    }
  }, [wordLexicon])

  /* const timeout = () => {
     const timeout = setTimeout(()=>{
       handleAudioStop();
       SpeechRecognition.stopListening();
     },10000);
   }*/
  const fetchPhoneme = async (url) => {
    let response;
    let data1;
    let blob = await fetch(url).then(r => r.blob());

    var reader = new FileReader();
    reader.readAsArrayBuffer(blob);
    reader.onloadend = (event) => {
      // The contents of the BLOB are in reader.result:
      data1 = reader.result;
    }
    const _headers = {
      'content-Type': 'multipart/form-data',
    }
    if (await Authentication.isAccessTokenAvailable()) {
      const token = await Authentication.getAccessToken();
      _headers.Authorization = `Bearer ${token}`;
    }
    await axios.post('https://predev-ims.jnj.com/api/tts/phoneme', blob,
      {
        headers: _headers,
      }).then((res) => {
        console.log(res.data)
        response = res.data.phonemes[0]
        setManyPhonemes(res.data.phonemes);
      }).catch((error) => console.log(error));
    //setPhoneme(response);

    /*const aTag = document.createElement('a');
    aTag.href = url;
    aTag.setAttribute('download', 'untitled.wav');
    document.body.append(aTag);
    aTag.click();
    aTag.remove();*/
  }
  useEffect(() => {
    if (mediaBlobUrl) {
      fetchPhoneme(mediaBlobUrl);
    }
  }, [mediaBlobUrl])

  /*useEffect(() => {
    setPhoneme('')
  }, [])*/

  let timeout;

  const fetchAudio = async (row) => {
    let payload;
    //let text1 = text.replace(textselected, `<phoneme alphabet="ipa" ph="${phonemeValue}">${textselected}</phoneme>`)
    payload =
    {
      "ssml": `<speak version=\"1.0\" xmlns=\"http://www.w3.org/2001/10/synthesis\" xml:lang=\"en-US\">\n                        <voice name="en-US-AvaNeural">\n                           
                <phoneme alphabet="ipa" ph="${row}"></phoneme></voice>\n                    </speak>`,

    }
    const _headers = {}
    if (await Authentication.isAccessTokenAvailable()) {
      const token = await Authentication.getAccessToken();
      _headers.Authorization = `Bearer ${token}`;
    }
    await axios.post(
      `https://predev-ims.jnj.com/api/tts/ssml`,
      payload,
      {
        headers: _headers,
        responseType: "blob",
      }
    ).then((response) => {
      const data = new Blob([response.data], { type: 'audio/wav' });
      const blobUrl = URL.createObjectURL(data);
      setAudio(blobUrl);
      //setLoader(false)
    }).catch((error) => {
      console.log(error)
    })
  }
  const startTimer = () => {
    // Clear any timers already running
    clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      if (audioSrc.current.ended) {
        setIsPlaying(false)
        clearTimeout(intervalRef.current)
      }
    }, 1000);
  };
  const handlePlay = async (row) => {
    await fetchAudio(row);
    setIsPlaying(true);
    audioSrc.current.play();
    startTimer();
  }

  const handleConfirm = async () => {
    if (props.fromLexicon) {
      if (wordLexicon.length > 0 && phoneme.length > 0) {
        setLexiconError(false)
        let res;
        let dbQuery;
        if (props.prevPhoneme.length === 0) {
          //dbQuery = `DO $$ DECLARE phoneme_id INT; BEGIN INSERT INTO "iMS".phm_ims_ttsphoneme (grapheme,phoneme) Values('${wordLexicon}','${phoneme}') RETURNING id INTO phoneme_id; INSERT INTO "iMS".phm_ims_ttslexiconphonemerel VALUES (${props.textselected},phoneme_id); END $$;`;
          props.setPhonemeValue(phoneme)
          props.setGrapheme(wordLexicon)
          props.setAddLexiModal(true)
          props.handleClose()
        }
        else {
          const _headers = {}
          if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
          }
          dbQuery = `Update "iMS". phm_ims_ttsphoneme set grapheme='${wordLexicon}' , phoneme = '${phoneme}' where id = ${props.textselected}`
          //res = await axios.get(`https://predev-ims.jnj.com/api/db/runquery?dbquery=${dbQuery}`);
          res = await axios.get(`https://predev-ims.jnj.com/api/db/runquery?dbquery=${dbQuery}`, {
            headers: _headers
          });
          if (res) {
            props.handleClose();
          }
        }
        //let res = await service.updateLexicon(selectedLexi?.id, props.grapheme, props.phoneme)
      }
      else {
        setLexiconError(true)
      }
    }
    else {
      if (props.textselected.length > 0 && phoneme.length > 0) {
        setLexiconError(false)
        props.setPhonemeValue(phoneme)
        props.setIsPhoneme(true)
        props.setModal();
      }
      else {
        setLexiconError(true)
      }
    }
  }
  const playAudio = async () => {
    let payload = {
      "ssml": `<speak version=\"1.0\" xmlns=\"http://www.w3.org/2001/10/synthesis\" xml:lang=\"en-US\">\n                        
      <voice name="en-US-AvaNeural">'${textselected}'</voice>\n                    </speak>`,
    };
    const _headers = {}
          if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
          }
    axios.post('https://predev-ims.jnj.com/api/tts/ssml', payload,
      {
        headers:_headers,
        responseType: 'blob'
      }
    ).then((res) => {
      const data = new Blob([res.data], { type: 'audio/wav' })
      const blobUrl = URL.createObjectURL(data);
      const audio1 = new Audio(blobUrl);
      audio1.play();
    }).catch((error) => { console.log(error) })
  }
  const fetchPhonemeFromAi = async () => {
    if (typeof (props.textselected) !== 'number' && (props.textselected)) {
      setShow(true)
      const _headers = {}
          if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
          }
      axios.get(`https://predev-ims.jnj.com/api/tts/llmphoneme?word=${props.textselected}`,{
        headers: _headers
      }).then((res) => {
        if (res.status === 200) {
          setShow(false)
          setSuggestPhoneme(res.data.phoneme)
          setReload(false)
        }
      }).catch((error) => {
        setShow(false);
        setReload(true)
        // alert('Unable to fetch.Please refresh')
      })
    }
    else {
      if (wordLexicon) {
        setShow(true)
        const _headers = {}
          if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
          }
        axios.get(`https://predev-ims.jnj.com/api/tts/llmphoneme?word=${wordLexicon}`,{
          headers:_headers
        }).then((res) => {
          if (res.status === 200) {
            setShow(false)
            setSuggestPhoneme(res.data.phoneme)
          }
          setReload(false)
        }).catch((error) => {
          // alert('Unable to fetch.Please refresh')
          setShow(false);
          setReload(true);
        })
      }
    }

    //setReload(false)
  }
  const phonemeDisplay = () => {
    console.log(manyPhonemes);
    return (manyPhonemes.map((val) => {
      if (val) {
        return (
          <div className="button-phoMany" onClick={() => {
            setPhoneme(val)
            setFromLibrary(false)
          }}><div style={{ width: '100%' }}>{val}</div>
          </div>
        )
      }
    }))
  }
  return (
    <Modal
      show={true}
      size="lg md sm xs"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="popup-transition"
      scrollable={false}
    >
      <div style={{ borderTop: `5px solid #1DA1E5`, overflow: "auto" }}>
        <div className="popup-cancel-btn-wrapper">
          <img
            src={popCancelBttn}
            alt=""
            onClick={e => {
              props.handleClose()
            }}
          />
        </div>
      </div>
      <Modal.Header><Modal.Title>Phoneme</Modal.Title></Modal.Header>
      <Modal.Body>
        <div className="selectedWords">
          {(!props.fromLexicon) ? <><label classname="label-1">Selected words :</label>
            <div style={{ marginLeft: '8px' }}>{textselected}</div></> : <>
            <input style={{ marginLeft: '8px' }} type="text" placeholder="Enter the word"
              value={wordLexicon} onChange={(e) => setWordLexicon(e.target.value)} />
          </>}
          <button style={{
            marginLeft: '8px',
            backgroundColor: '#FFFF'
          }} onClick={() => playAudio()}><span className="css-534" aria-hidden="true" style={{ height: '10%' }}></span>
            <img src={SpeakerBlue} alt="Play selected text" />
          </button>
        </div>
        <div className='Suggested-Phoneme' style={{ display: 'flex' }}>
          <span>Suggested Phoneme :</span>
          <div style={{
            border: 'solid 1px black', width: '20rem', height: '25px', marginLeft: '8px',
            display: 'flex', justifyContent: 'space-between'
          }}>
            <span style={{ padding: '0px 5px' }}>{(!show) && suggestPhoneme}</span>
            {(!show) ? <button
              style={{ background: 'transparent' }}
              onClick={() => {
                setReload(true)
                fetchPhonemeFromAi()
              }}><img src={RefreshButton} alt="Refresh suggested phoneme" /></button> : <span style={{ marginLeft: "30%" }}><img style={{ width: '14%' }} src={imsLoader} alt="Loading" /></span>}
          </div>
          <div>
            <button className="button-pho" style={{ margin: '0px 12px', padding: '2px 8px 2px 8px' }}
              onClick={() => {
                setPhoneme(suggestPhoneme)
                setFromLibrary(false)
              }}><div>Use this phoneme</div></button>
          </div>
        </div>
        <div className="label-1">Phoneme</div>
        <div>{props.prevPhoneme}</div>
        <div className="phoneme-text-container">
          <div className="ms-TextField-fieldGroup fieldGroup-563">
            <input type="text" placeholder="Drag or click the phonemes from the library"
              value={phoneme}
              onChange={(e) => setPhoneme(e.target.value)}
              style={{
                width: "33.5rem",
                border: "none"
              }} />
            <button onClick={() => {
              setPhoneme('')
            }}><img src={popCancelBttn} alt="Clear" /></button>
          </div>
          <div className="phoneme-preview-audio-button audio-button">
            <button
              type="button"
              className="circlebutton"
              onClick={() => {
                if (!isPlaying) {
                  handlePlay(phoneme)
                }
              }}
              aria-label="Play"
            >
              <span className="flexContainer-177">
                {(!isPlaying) ? <img src={PlayButton} alt="Play" /> : <img src={PauseButton} alt="Pause" />}
              </span>
            </button>
          </div>
        </div>
        <div>
          <div style={{ marginTop: "1rem" }}>
            <label className={(isLibrary) ? "label1 underline" : "labe1"}
              style={{ marginLeft: "15px" }}
              onClick={() => {
                setIsSpeaking(false)
                setIsLibrary(true)
              }}>PhonemeLibrary</label>
            <label className={(isSpeaking) ? "label1 underline" : "labe1"}
              style={{ marginLeft: "15px" }}
              onClick={() => {
                setIsSpeaking(true)
                setIsLibrary(false)
              }}>Recognize By Speaking</label>
          </div>
          {(isSpeaking) &&
            <Box className="box-container">
              {(manyPhonemes.length > 0) ? <><button className='refresh-button' onClick={() => {
                setManyPhonemes([]);
                setIsRecording(false);
              }}>
                <img style={{ width: '100%' }} src={RefreshButton} alt="Refresh" />
              </button><div>Refresh</div></>
                : <button className="spaekerClick"
                  style={{
                    marginTop: "0.5rem",
                    backgroundColor: "#FFFF"
                  }}
                  onClick={() => {
                    /*if (!listening) {
                      resetTranscript();
                      SpeechRecognition.startListening({ continuous: true });
                    }
                    else if (listening) {
                      SpeechRecognition.stopListening();
                    }*/
                    if (!isRecording) {
                      startRecording()

                      setIsRecording(true)
                    }
                    else {
                      stopRecording()

                      setIsRecording(false)
                    }

                  }}>{(!isRecording) ? <img src={Speaker} alt="Start recording" /> : <img src={RedStop} alt="Stop recording" />}</button>}
              {(manyPhonemes.length === 0) && <> {(!isRecording) ? <><div className="Sp-content">Press to start speaking</div>
                <div className="Sp-content">Your recording will be used to generate phonemes.</div></>
                : <>
                  <div className="Sp-content"><img src={RecordingIcon} alt="Recording" /></div>
                  <div className="Sp-content">You recording time must be between 1s and 10s (inclusive).</div>
                  <div className="Sp-content">Recording ... Press button to stop</div></>}</>}
              {(manyPhonemes.length > 0) && <div style={{
                display: 'flex', flexDirection: 'column',
                marginTop: '10px', alignItems: 'center'
              }}>
                <span style={{ paddingTop: '9px' }}>Phonemes possibly matched to your speaking:</span>{phonemeDisplay()}</div>}
            </Box>}
          {(isLibrary) &&
            <Box className="box-container">
              <PhonemeLibrary
                phoneme={phoneme}
                fromLibrary={fromLibrary}
                setFromLibrary={setFromLibrary}
                setPhoneme={setPhoneme} />
            </Box>}
          {(lexiconError) ? <span className="error-check">Grapheme/Phoneme not selected</span>
            : <span className="error-check"></span>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {(!props.fromLexicon) && <button style={{ marginRight: "70px" }}
          onClick={() => {
            props.handleClose()
            props.setAddLexiModal(true)
            props.setPhonemeValue(phoneme)
          }}>
          <span style={{ marginRight: "5px" }}>
            <img src={PlusIconBlue} alt="Add" /></span>
          <span>Add to lexicon</span></button>}
        <Button text="Confirm" customColor='#0074B0' action={() => {
          handleConfirm()
        }} />
        <Button text="Cancel" customColor="#0074B0" action={() => {
          props.handleClose()
        }} />
      </Modal.Footer>
    </Modal>
  )
}
export default AliasModal;